module.exports = __webpack_public_path__ + "img/cscs 2.610842d7.png";